// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"23":"fc85de2e","54":"0e9a6bfc","102":"fb194ec9","182":"07ece654","259":"a2323658","387":"92d41436","418":"3f0793a4","469":"718eff6c","496":"c53690f0","563":"0671722a","592":"a433eb98","635":"544a4b06","915":"5dbcca1b","983":"25e66f8f"}[chunkId] + ".js";
};